import { funcCompaniesHouseManager } from '@/plugins/axios';


export const getCompaniesHouseSummary = (companyNumber) => {
  return funcCompaniesHouseManager.get(`companieshouse/summary/${companyNumber}`);
};


export const getPersonsWithSignificantControl = (companyNumber) => {
  return funcCompaniesHouseManager.get(`companieshouse/psc/${companyNumber}`);
};




